module.exports = __webpack_public_path__ + "img/2025-05_commencement.7c8e2353.webp";